import { render, staticRenderFns } from "./ContractPlaceForm.vue?vue&type=template&id=4a118dae&scoped=true&"
import script from "./ContractPlaceForm.vue?vue&type=script&lang=js&"
export * from "./ContractPlaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a118dae",
  null
  
)

export default component.exports